import { defineMessage } from 'services/localization';

export const messages = {
    editingMatrixForTheStep: defineMessage('editing_matrix_for_the_step_step'),
    save: defineMessage('save'),
    invalidConditions: defineMessage('please_ensure_that_all_set_conditions_are_valid'),
    alertMessage: defineMessage('these_rules_will_define_val_matrix_for_the_step'),
};
